// extracted by mini-css-extract-plugin
module.exports = {"list":"HowToPlay_list__iiCBo","text":"HowToPlay_text__ocM1I","icon":"HowToPlay_icon__lc_h3"};